import BoxPosition from '../../geometry/box';
import Point2D from '../../geometry/point2D';

// Calculate max constraint in the relative coordinate world.
export default function calculateRelativeMaxConstraint(
  boundingBox: BoxPosition,
  width: number,
  height: number
): Point2D {
  return {
    x: Math.max(1 - (boundingBox.x + boundingBox.width - width), 0),
    y: Math.max(1 - (boundingBox.y + boundingBox.height - height), 0),
  };
}
